<template>
  <label
    class="flex gap-4 items-center [&>.checkbox]:hover:bg-neutral-100 cursor-pointer"
  >
    <CheckboxRoot
      :checked="checked"
      class="flex h-[20px] w-[20px] appearance-none items-center justify-center rounded-[4px] bg-[#2c3233] outline-none border border-solid border-[#696d6d]"
      @update:checked="toggleCheck"
    >
      <CheckboxIndicator
        class="bg-orange-600 text-white h-[18px] w-[18px] rounded-[2px] flex items-center justify-center"
      >
        <span class="h-3 w-3">
          <svg-icon
            :width="'16'"
            :height="'16'"
            icon="app-icons/check"
            fill="currentColor"
          />
        </span>
      </CheckboxIndicator>
    </CheckboxRoot>
    <span class="select-none text-gray-600 text-[15px]">
      <slot />
    </span>
  </label>
</template>

<script>
import { CheckboxIndicator, CheckboxRoot } from 'radix-vue';
import SvgIcon from '@ui/components/SvgIcon.vue';

export default {
  components: {
    SvgIcon,
    CheckboxRoot,
    CheckboxIndicator,
  },

  props: {
    checked: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    toggleCheck(value) {
      this.$emit('update:checked', value);
    },
  },
};
</script>
